import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'

export const MenuTabContainer = styled.div`
  padding: 8px;

  ${mediaQueryUp('m')} {
    padding: 32px;
    background: ${({ theme }) => theme.colors.bgColor};
    border: 1px solid ${({ theme }) => theme.colors.gray[200]};
    border-radius: 16px;
  }
`

export const PillsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  margin: 0 -2rem;
  padding: 0 1rem;
`

export const MenuTabPill = styled.button<{
  isSelected: boolean
}>`
  position: relative;
  display: flex;
  padding: 10px 16px;
  border-radius: 3rem;
  align-items: center;
  background: ${({ theme, isSelected }) => (isSelected ? theme.colors.gray[50] : theme.colors.gray[0])};
  cursor: pointer;
  white-space: nowrap;

  font-weight: ${({ theme }) => theme.text.fontWeight.medium};
  font-size: ${({ theme }) => theme.text.fontSize.base};
  line-height: ${({ theme }) => theme.text.lineHeight.loose};
  color: ${({ theme }) => theme.colors.gray[1000]};

  &:after {
    content: '';
    border-radius: 3rem;
    position: absolute;
    inset: 0;
    border: ${({ theme, isSelected }) => (isSelected ? `2px solid ${theme.colors.gray[1000]}` : `1px solid ${theme.colors.gray[300]}`)};
  }
`
